<template>
  <div>
    <div class="box">
      <form>
        <div
          class="alert alert-warning text-left"
          v-if="stripeValidationError"
          v-html="stripeValidationError"
        ></div>
        <div class="form-row">
          <div class="col-6">
            <label for="exampleFormControlSelect1">Card Holder Name</label>
            <input
              type="text"
              v-model="checkout.cardholdername"
              class="form-control"
              id="cardholdername"
              placeholder="Name On Card"
            />
            <!-- <div id='card-name-element' class='input-value'></div> -->
          </div>
        </div>
        <div class="form-row">
          <div class="col-6">
            <label for="exampleFormControlSelect1">Credit Card Number</label>
            <div id="card-number-element" class="form-control input-value"></div>
          </div>
          <div class="col-6">
            <label for="exampleFormControlSelect1">Exp. Date</label>
            <div id="card-expiry-element" class="form-control input-value"></div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6">
            <label for="exampleFormControlSelect1">CVC</label>
            <div id="card-cvc-element" class="form-control input-value"></div>
          </div>
        </div>
      </form>
    </div>
    <div class="action-btn text-center">
      <!-- <router-link
        class="btn col-3 btn-secondary mr-3"
        to="/financial-statements"
        :is-loading="isLoading"
        :disabled="isLoading"
        :status="status"
      >Cancel</router-link> -->
      <button
        class="btn col-3 btn-secondary mr-3"
        @click="clearInputs()"
        :is-loading="isLoading"
        :disabled="isLoading"
        :status="status"
      >{{ cancelButtonText }}</button>
      <button
        class="btn col-3 btn-primary"
        :is-loading="isLoading"
        :disabled="isLoading"
        :status="status"
        @click.prevent="localValidation"
      >
        <span>{{submitButtonText}}</span>
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: function () {
    return {
      stripeValidationError: '',
      options: {
        format: 'MM/YY',
        useCurrent: false
      },
      stripe: null
    }
  },
  computed: {
    ...mapState({
      notifications: state => state.payments.notifications
    })
  },
  props: {
    confirmationPayment: Function,
    isLoading: Boolean,
    status: Boolean,
    submitButtonText: String,
    cancelButtonText: String,
    closeIntent: Function,
    checkout: Object
  },
  mounted () {
    this.stripe = window.Stripe(`${process.env.STRIPE_KEY}`)
    this.createAndMountFormElements()
  },
  methods: {
    createAndMountFormElements () {
      var elements = this.stripe.elements()
      // number
      this.checkout.cardNumber = elements.create('cardNumber')
      this.checkout.cardNumber.mount('#card-number-element')
      // expiry
      this.checkout.cardExpiry = elements.create('cardExpiry')
      this.checkout.cardExpiry.mount('#card-expiry-element')
      // cvc
      this.checkout.cardCvc = elements.create('cardCvc')
      this.checkout.cardCvc.mount('#card-cvc-element')
      // this.checkout.cardName.on('change', this.setValidationError)
      this.checkout.cardNumber.on('change', this.setValidationError)
      this.checkout.cardExpiry.on('change', this.setValidationError)
      this.checkout.cardCvc.on('change', this.setValidationError)
    },
    setValidationError (event) {
      this.stripeValidationError = event.error ? event.error.message : ''
    },
    localValidation () {
      let errors = ''
      this.$store.commit('notifications_commit', '')
      if (this.checkbox === '') {
        errors += 'Please Agree terms & conditions<br>'
      }
      if (!this.checkout.cardholdername.trim()) {
        console.log(
          'this.checkout.cardNumber',
          this.checkout.cardNumber._empty
        )
        errors += 'Please Enter the Card Holder Name<br>'
      }
      if (!this.checkout.cardNumber._complete) {
        errors += 'Please Enter Valid Card Number<br>'
      }
      if (!this.checkout.cardCvc._complete) {
        errors += 'Please Enter Valid CVC<br>'
      }
      if (!this.checkout.cardExpiry._complete) {
        errors += 'Please Enter Valid Card Expiry<br>'
      }
      if (errors !== '') {
        console.log('errors', errors)
        errors = errors.slice(0, -4)
        this.$store.commit('notifications_commit', errors)
        return false
      } else {
        let cardName = document.getElementById('cardholdername').value
        this.confirmationPayment(cardName, this.stripe)
      }
    },
    clearInputs () {
      this.checkout.cardholdername = ''
      this.checkout.cardNumber.clear()
      this.checkout.cardExpiry.clear()
      this.checkout.cardCvc.clear()
      this.closeIntent()
    }
  }
}
</script>
<style scoped>
.borderit {
  border: 1px solid;
}
.stripe-element-container {
  padding-top: 0.55rem;
  padding-bottom: 0.5rem;
}
.input-value {
  display: block;
  width: 100%;
  /* height: calc(1.5em + 0.75rem + 2px); */
  height: 25px;
  padding: 0.375rem 0.75rem;
  font-size: 16px;
  font-weight: 400;
  /* line-height: 1.5; */
  color: #495057;

  background-clip: padding-box;

  border-radius: 5px;
  background-color: #fff;
  border: 1px solid #56baed;
  /* height: 50px; */
  padding-left: 20px;
}
.input-value:focus {
  border-color: #ff0000;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(255, 0, 0, 0.6);
}
.swal-button--confirm {
  border-radius: 33px;
}

.swal-button--cancel {
  border-radius: 33px;
}
.checkout {
  padding-top: 80px;
}
.checkout-requirement-list {
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/payments/paymentInputs.vue